module.exports = __webpack_public_path__ + "media/images/symbols/white-caret-left-d7528cac6af6ed5f699f7b7685ecd846.svg";